<div
  data-cy="vehicle-upload-document-form"
  class="cpt-modal ef-scrollbar relative dialog-content-p-0 mat-dialog-actions-pb-20"
  >
  <h2 class="font-canelablack-primary text-4xl" mat-dialog-title>
    @if (data?.type === 'document') {
      <T
      str="Add document"
      key="customerPortal.customer-portal.vehicle.documents-upload.title"
      tags="customer-portal, 3.1"
    ></T>
  }
  @if (!(data?.type === 'document')) {
    <T
    str="Add image"
    key="customerPortal.customer-portal.add-images"
    tags="customer-portal, 3.1"
  ></T>
}
</h2>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="documentUploadFormGroup">
    <div>
      <mat-form-field
        class="hidden md:block w-full mt-2.5"
        appearance="fill"
        >
        <mat-label>{{ 'type' | sharedTranslate }}</mat-label>
        <mat-select
          formControlName="documentType"
          required
          data-cy="vehicle-upload-document-select"
          >
          @for (d of uploadableDocumentTypes; track d) {
            <mat-option [value]="d">
              <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: d?.value?.toLowerCase(),
                    key: d?.key
                  }
                "
            ></ng-container>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="block md:hidden w-full mt-2.5"
      appearance="fill"
      >
      <mat-label>{{ 'type' | sharedTranslate }}</mat-label>
      <select matNativeControl formControlName="documentType" required>
        @for (d of uploadableDocumentTypes; track d) {
          <option [ngValue]="d">
            <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: d?.value?.toLowerCase(),
                    key: d?.key
                  }
                "
          ></ng-container>
        </option>
      }
    </select>
  </mat-form-field>
</div>

<mat-divider class="mt-0 mb-6"></mat-divider>

<div class="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-12">
  <!-- Image preview -->
  @if (selectedFileType !== 'pdf') {
    <div
      class="image-preview col-span-1 box-border bg-cover bg-center w-full md:w-[300px] h-[200px] flex justify-center bg-mat-ef-revolution-grey-two-50"
      >
      @if (fileUploaded) {
        <img alt="image preview" [src]="preview" />
      }
      @if (!fileUploaded) {
        <div
          class="w-full h-full flex items-center justify-center"
          >
          <mat-icon
            class="w-12 h-12"
            svgIcon="add_photo_alternate"
          ></mat-icon>
        </div>
      }
    </div>
  }

  <!-- Pdf preview -->
  @if (selectedFileType === 'pdf') {
    <div
      class="box-border bg-cover bg-center w-full md:w-[300px] h-[200px] flex justify-center bg-mat-ef-grey-dark-50"
      >
      <div class="w-full h-full">
        <ngx-extended-pdf-viewer
          [src]="preview"
          [logLevel]="0"
          [showToolbar]="false"
          [showDownloadButton]="false"
        ></ngx-extended-pdf-viewer>
      </div>
    </div>
  }

  <div
    class="flex flex-col col-span-1 gap-5"
    data-cy="vehicle-upload-document-accepted"
    >
    <p
      class="text-sm leading-5 mt-0 md:mt-5 text-mat-ef-revolution-grey-two-200"
      >
      <!-- File requirements, based on format-->
      @if (acceptedTypes === 'image') {
        <span>
          <T
          str="JPG, PNG (max. 10MB)"
          key="customerPortal.customer-portal.vehicle.documents-upload.requirements.image"
          tags="customer-portal, 3.1"
        ></T>
      </span>
    }
    @if (acceptedTypes === 'pdf') {
      <span>
        <T
        str="PDF (max. 10MB)"
        key="customerPortal.customer-portal.vehicle.documents-upload.requirements.pdf"
        tags="customer-portal, 3.1"
      ></T>
    </span>
  }
  @if (acceptedTypes === 'image,pdf') {
    <span>
      <T
      str="JPG, PNG, PDF (max. 10MB)"
      key="customerPortal.customer-portal.vehicle.documents-upload.requirements.imageorpdf"
      tags="customer-portal, 3.1"
    ></T>
  </span>
}
<br />
<!-- Incorrect size notifier-->
@if (!propperSize) {
  <span class="text-mat-ef-red-secondary-500">
    <T
    str="Incorrect file size"
    key="customerPortal.customer-portal.vehicle.documents-upload.requirements.incorrect-size"
    tags="customer-portal, 3.1"
  ></T>
</span>
}
@if (fileUploaded && !isAllowedImageType) {
  <span
    class="text-mat-ef-red-secondary-500"
    >
    <T
    str="Incorrect file type."
    key="customerPortal.customer-portal.vehicle.documents-upload.requirements.incorrect-format"
    tags="customer-portal, 3.1"
  ></T>
</span>
}
</p>

<div class="relative">
  @if (acceptedTypes === 'image' && vehicleDocument.type) {
    <input
      data-cy="vehicle-upload-document-input"
      class="absolute top-0 opacity-0 z-50 h-full w-full cursor-pointer"
      type="file"
      accept=".jpg, .png"
      (change)="onFileSelected($event)"
      />
  }
  @if (acceptedTypes === 'image,pdf' && vehicleDocument.type) {
    <input
      data-cy="vehicle-upload-document-input"
      class="absolute top-0 opacity-0 z-50 h-full w-full cursor-pointer"
      type="file"
      accept=".jpg, .png, .pdf"
      (change)="onFileSelected($event)"
      />
  }
  @if (acceptedTypes === 'pdf' && vehicleDocument.type) {
    <input
      data-cy="vehicle-upload-document-input"
      class="absolute top-0 opacity-0 z-50 h-full w-full cursor-pointer"
      type="file"
      accept=".pdf"
      (change)="onFileSelected($event)"
      />
  }

  <button
    class="revolution button-upload w-full md:w-fit"
    mat-button
    mat-stroked-button
    color="secondary"
    [disabled]="!vehicleDocument.type"
    >
    <mat-icon class="mr-1" svgIcon="add_photo_alternate"></mat-icon>
    @if (!fileUploaded) {
      <span>
        <T
        str="Select file"
        key="customerPortal.customer-portal.vehicle.documents-upload.select-file"
        tags="customer-portal, 3.1"
      ></T>
    </span>
  }
  @if (fileUploaded) {
    <span>
      <T
      str="Replace file"
      key="customerPortal.customer-portal.vehicle.documents-upload.replace-file"
      tags="customer-portal, 3.1"
    ></T>
  </span>
}
</button>
</div>

<div>
  <mat-form-field
    class="prefix-large w-full mt-2.5"
    appearance="fill"
    >
    <mat-label for="name"
      ><T
      str="Name"
      key="customerPortal.customer-portal.vehicle.documents-upload.name"
      tags="customer-portal, 3.1"
      ></T
    ></mat-label>
    <input
      matInput
      type="text"
      formControlName="name"
      [errorStateMatcher]="matcher"
      />
    @if (documentUploadFormGroup.get('name').errors?.maxlength) {
      <mat-error
        >
        <T
        str="Maximum filename length excceeded"
        key="customerPortal.customer-portal.vehicle.documents-upload.error.maxlength"
        tags="customer-portal, 3.1"
      ></T>
    </mat-error>
  }
  @if (documentUploadFormGroup.get('name').errors?.required) {
    <mat-error
      >
      <T
      str="The document is required"
      key="customerPortal.customer-portal.vehicle.documents-upload.error.required"
      tags="customer-portal, 3.1"
    ></T>
  </mat-error>
}
</mat-form-field>
</div>
</div>
</div>
</form>
</mat-dialog-content>

<mat-divider class="mt-0 mb-4"></mat-divider>

<mat-dialog-actions>
  <button class="dialog-close-button" [mat-dialog-close]="false">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <button
    data-cy="vehicle-upload-document-submit"
    cdkFocusInitial
    class="revolution w-full md:w-auto"
    color="secondary"
    mat-button
    mat-flat-button
    (click)="onUploadDocumentFormSubmit()"
    cdkFocusInitial
      [disabled]="
        !documentUploadFormGroup.valid || saving || !isAllowedImageType
      "
    >
    @if (saving) {
      <mat-spinner
        class="inline-block mr-2.5"
        [diameter]="16"
      ></mat-spinner>
    }
    <span>{{ 'save' | sharedTranslate }}</span>
  </button>
</mat-dialog-actions>
</div>
